import React, {
  useState,
  useEffect,
  useReducer,
  useContext,
  useRef
} from "react";
import {
  toast
} from "react-toastify";
import {
  useHistory
} from "react-router-dom";

import {
  makeStyles
} from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import {
  Facebook,
  Instagram,
  WhatsApp
} from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";

import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import BlockIcon from "@material-ui/icons/Block";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import Tooltip from "@material-ui/core/Tooltip";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import Skeleton from "@material-ui/lab/Skeleton";

import api from "../../services/api";
import ContactModal from "../../components/ContactModal";
import ConfirmationModal from "../../components/ConfirmationModal";

import {
  i18n
} from "../../translate/i18n";
import MainHeader from "../../components/MainHeader";
import toastError from "../../errors/toastError";

import {
  AuthContext
} from "../../context/Auth/AuthContext";
import {
  Can
} from "../../components/Can";
import NewTicketModal from "../../components/NewTicketModal";
import {
  TagsFilter
} from "../../components/TagsFilter";
import PopupState,
  {
  bindTrigger,
  bindMenu
} from "material-ui-popup-state";
import formatSerializedId from "../../utils/formatSerializedId";
import {
  v4 as uuidv4
} from "uuid";

import {
  ArrowDropDown,
  Backup,
  ContactPhone
} from "@material-ui/icons";
import {
  Menu,
  MenuItem
} from "@material-ui/core";


import ContactImportWpModal from "../../components/ContactImportWpModal";
import ContactOverviewDrawer from "../../components/ContactOverviewDrawer";

import {
  KoraxPage,
  KoraxPageHeader,
  KoraxButton
} from "../../components/KoraxUI";

import useCompanySettings from "../../hooks/useSettings/companySettings";
import {
  TicketsContext
} from "../../context/Tickets/TicketsContext";

import {
  ComposableMap,
  Geographies,
  Geography,
  Marker
} from "react-simple-maps";

// ================= GEO / DDD CONFIG DO MAPA =================

const geoUrl =
  "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/brazil-states.geojson";

const markers = [
  { markerOffset: -30, name: "Aracaju", coordinates: [-37.0717, -10.9472] },
  { markerOffset: 15, name: "Belém", coordinates: [-48.4878, -1.4558] },
  { markerOffset: 15, name: "Belo Horizonte", coordinates: [-43.9378, -19.8157] },
  { markerOffset: 15, name: "Boa Vista", coordinates: [-60.6739, 2.8195] },
  { markerOffset: 15, name: "Brasília", coordinates: [-47.8825, -15.7942] },
  { markerOffset: 15, name: "Campo Grande", coordinates: [-54.6464, -20.4428] },
  { markerOffset: 15, name: "Cuiabá", coordinates: [-56.0969, -15.6011] },
  { markerOffset: 15, name: "Curitiba", coordinates: [-49.2736, -25.4296] },
  { markerOffset: 15, name: "Florianópolis", coordinates: [-48.5492, -27.5969] },
  { markerOffset: 15, name: "Fortaleza", coordinates: [-38.5267, -3.71839] },
  { markerOffset: 15, name: "Goiânia", coordinates: [-49.2736, -16.6869] },
  { markerOffset: 15, name: "João Pessoa", coordinates: [-34.8631, -7.1195] },
  { markerOffset: 15, name: "Macapá", coordinates: [-51.0667, 0.0333] },
  { markerOffset: 15, name: "Maceió", coordinates: [-35.7353, -9.6658] },
  { markerOffset: 15, name: "Manaus", coordinates: [-60.025, -3.10194] },
  { markerOffset: 15, name: "Natal", coordinates: [-35.2094, -5.795] },
  { markerOffset: 15, name: "Palmas", coordinates: [-48.3347, -10.1844] },
  { markerOffset: 15, name: "Porto Alegre", coordinates: [-51.23, -30.0331] },
  { markerOffset: 15, name: "Porto Velho", coordinates: [-63.9039, -8.7619] },
  { markerOffset: 15, name: "Recife", coordinates: [-34.8811, -8.05389] },
  { markerOffset: 15, name: "Rio Branco", coordinates: [-67.8099, -9.9747] },
  { markerOffset: 15, name: "Rio de Janeiro", coordinates: [-43.1729, -22.9068] },
  { markerOffset: 15, name: "Salvador", coordinates: [-38.4813, -12.9716] },
  { markerOffset: 15, name: "São Luís", coordinates: [-44.3028, -2.5283] },
  { markerOffset: 15, name: "São Paulo", coordinates: [-46.6333, -23.5505] },
  { markerOffset: 15, name: "Teresina", coordinates: [-42.8039, -5.0892] },
  { markerOffset: 15, name: "Vitória", coordinates: [-40.3378, -20.3194] },
];

const dddList = {
  "11": "São Paulo",
  "12": "São Paulo",
  "13": "São Paulo",
  "14": "São Paulo",
  "15": "São Paulo",
  "16": "São Paulo",
  "17": "São Paulo",
  "18": "São Paulo",
  "19": "São Paulo",
  "21": "Rio de Janeiro",
  "22": "Rio de Janeiro",
  "24": "Rio de Janeiro",
  "27": "Espírito Santo",
  "28": "Espírito Santo",
  "31": "Minas Gerais",
  "32": "Minas Gerais",
  "33": "Minas Gerais",
  "34": "Minas Gerais",
  "35": "Minas Gerais",
  "37": "Minas Gerais",
  "38": "Minas Gerais",
  "41": "Paraná",
  "42": "Paraná",
  "43": "Paraná",
  "44": "Paraná",
  "45": "Paraná",
  "46": "Paraná",
  "47": "Santa Catarina",
  "48": "Santa Catarina",
  "49": "Santa Catarina",
  "51": "Rio Grande do Sul",
  "53": "Rio Grande do Sul",
  "54": "Rio Grande do Sul",
  "55": "Rio Grande do Sul",
  "61": "Distrito Federal/Goiás",
  "62": "Goiás",
  "63": "Tocantins",
  "64": "Goiás",
  "65": "Mato Grosso",
  "66": "Mato Grosso",
  "67": "Mato Grosso do Sul",
  "68": "Acre",
  "69": "Rondônia",
  "71": "Bahia",
  "73": "Bahia",
  "74": "Bahia",
  "75": "Bahia",
  "77": "Bahia",
  "79": "Sergipe",
  "81": "Pernambuco",
  "82": "Alagoas",
  "83": "Paraíba",
  "84": "Rio Grande do Norte",
  "85": "Ceará",
  "86": "Piauí",
  "87": "Pernambuco",
  "88": "Ceará",
  "89": "Piauí",
  "91": "Pará",
  "92": "Amazonas",
  "93": "Pará",
  "94": "Pará",
  "95": "Roraima",
  "96": "Amapá",
  "97": "Amazonas",
  "98": "Maranhão",
  "99": "Maranhão",
};

// ================= REDUCER =================

const reducer = (state, action) => {
  if (action.type === "LOAD_CONTACTS") {
    const contacts = action.payload;
    const newContacts = [];

    contacts.forEach((contact) => {
      const contactIndex = state.findIndex((c) => c.id === contact.id);
      if (contactIndex !== -1) {
        state[contactIndex] = contact;
      } else {
        newContacts.push(contact);
      }
    });

    return [...state, ...newContacts];
  }

  if (action.type === "UPDATE_CONTACTS") {
    const contact = action.payload;
    const contactIndex = state.findIndex((c) => c.id === contact.id);

    if (contactIndex !== -1) {
      state[contactIndex] = contact;
      return [...state];
    } else {
      return [contact, ...state];
    }
  }

  if (action.type === "DELETE_CONTACT") {
    const contactId = action.payload;

    const contactIndex = state.findIndex((c) => c.id === contactId);
    if (contactIndex !== -1) {
      state.splice(contactIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  pageRoot: {
    flex: "1 1 auto",
    minHeight: "calc(100vh - 56px)",
    display: "block",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    background: "linear-gradient(145deg,#EEF5FF 0%,#F8FAFC 100%)",

    [theme.breakpoints.down("sm")]: {
      paddingBottom: theme.spacing(12),
      minHeight: "100vh",
      display: "block",
      overflowY: "visible"
    }
  },
  hero: {
    flexShrink: 0, borderRadius: 16, padding: theme.spacing(1.5, 2.5),
    marginBottom: theme.spacing(1.5),
    background: theme.palette.type === "dark"
      ? "linear-gradient(135deg, #0A1628 0%, #0D1F3C 100%)"
      : "linear-gradient(135deg, #EBF3FF 0%, #D6E9FF 100%)",
    border: theme.palette.type === "dark"
      ? "1px solid rgba(0,140,255,0.18)" : "1px solid rgba(0,102,255,0.12)",
    boxShadow: "0 4px 16px rgba(0,102,255,0.07)",
    display: "flex", alignItems: "center", justifyContent: "space-between",
    gap: theme.spacing(2), position: "relative", overflow: "hidden",
  },
  heroBgCircle: {
    position: "absolute", right: -20, top: -20, width: 140, height: 140,
    borderRadius: "50%", pointerEvents: "none",
    background: "radial-gradient(circle, rgba(0,102,255,0.07) 0%, transparent 70%)",
  },
  heroLeft: { display: "flex", alignItems: "center", gap: theme.spacing(1.5), zIndex: 1 },
  heroIcon: {
    width: 48, height: 48, borderRadius: 14, flexShrink: 0, fontSize: "1.3rem",
    background: "linear-gradient(135deg, #0066FF 0%, #00A3FF 100%)",
    display: "flex", alignItems: "center", justifyContent: "center",
    boxShadow: "0 6px 16px rgba(0,102,255,0.3)",
  },
  heroTitle: {
    fontWeight: 800, fontSize: "1.1rem", letterSpacing: "-0.3px",
    color: theme.palette.type === "dark" ? "#ffffff" : "#0A1628",
  },
  heroSubtitle: {
    fontSize: "0.75rem", marginTop: 2,
    color: theme.palette.type === "dark" ? "rgba(255,255,255,0.5)" : "rgba(10,22,40,0.55)",
  },
  heroRight: { display: "flex", alignItems: "center", gap: theme.spacing(1.5), zIndex: 1 },
  heroChip: {
    background: theme.palette.type === "dark" ? "rgba(255,255,255,0.07)" : "rgba(255,255,255,0.9)",
    border: "1px solid rgba(0,102,255,0.15)", borderRadius: 10,
    fontWeight: 700, fontSize: "0.72rem",
    color: theme.palette.type === "dark" ? "rgba(255,255,255,0.7)" : "#0A1628",
  },
  headerChip: {
    backgroundColor: "#EAF1FF", color: "#2f4b7c",
    border: "1px solid #d7e5ff", fontWeight: 500, fontSize: "0.72rem", height: 24,
  },
  controlsPaper: {
    marginBottom: theme.spacing(1.5),
    borderRadius: 24,
    border: "1px solid #E2E8F0",
    boxShadow: "0 18px 45px rgba(15,23,42,.06)",
    padding: theme.spacing(1.4),
    backgroundColor: "#FFFFFF",
  },
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      backgroundColor: theme.palette.background.default,
    },
    "& .MuiInputBase-input": {
      fontSize: "0.82rem",
      paddingTop: 13,
      paddingBottom: 13,
    },
  },
  actionButton: {
    minHeight: 38,
    borderRadius: 10,
    fontWeight: 700,
    fontSize: ".71rem",
    padding: "7px 11px",
    boxShadow: "0 5px 12px rgba(7,64,171,.12)",
    textTransform: "none"
  },
  tabsWrap: {
    marginBottom: theme.spacing(1.2),
    borderRadius: 20,
    border: "1px solid #E2E8F0",
    backgroundColor: "#FFFFFF",
    overflow: "hidden",
    boxShadow: "0 10px 26px rgba(15,23,42,.04)",
  },
  tabsRoot: {
    minHeight: 40,
    "& .MuiTab-root": {
      minHeight: 40,
      fontSize: "0.78rem",
      fontWeight: 600,
      textTransform: "none",
    },
  },
  mainPaper: {
    flex: "1 1 auto",
    padding: 0,
    overflowY: "auto",
    overflowX: "hidden",
    ...theme.scrollbarStyles,
    borderRadius: 24,
    border: "1px solid #E2E8F0",
    background: "#FFFFFF",
    boxShadow: "0 18px 45px rgba(15,23,42,.06)",
    [theme.breakpoints.down("sm")]: {
      overflowY: "visible",
      height: "auto",
      maxHeight: "none",
      borderRadius: 20,
    },
  },
  premiumStatsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: 10,
    marginBottom: 12,

    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
    },

    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      gap: 8,
      marginBottom: 10
    }
  },

  premiumStatCard: {
    minHeight: 74,
    borderRadius: 16,
    background: "#FFFFFF",
    border: "1px solid rgba(226,232,240,.95)",
    boxShadow: "0 7px 20px rgba(15,23,42,.045)",
    padding: "10px 12px",
    display: "flex",
    alignItems: "center",
    gap: 10,
    overflow: "hidden",
    position: "relative",
    transition: "transform .18s ease, box-shadow .18s ease",

    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 10px 24px rgba(15,23,42,.07)"
    },

    [theme.breakpoints.down("sm")]: {
      minHeight: 82,
      padding: "10px",
      alignItems: "flex-start"
    }
  },

  premiumStatIcon: {
    width: 38,
    height: 38,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#FFFFFF",
    flexShrink: 0,
    boxShadow: "0 7px 16px rgba(15,23,42,.12)",

    "& svg": {
      fontSize: 19
    },

    [theme.breakpoints.down("sm")]: {
      width: 36,
      height: 36,
      borderRadius: 11,

      "& svg": {
        fontSize: 18
      }
    }
  },

  premiumStatLabel: {
    fontSize: ".67rem",
    color: "#64748B",
    fontWeight: 750,
    lineHeight: 1.2
  },

  premiumStatValue: {
    marginTop: 1,
    fontSize: "1.18rem",
    color: "#0F172A",
    fontWeight: 900,
    lineHeight: 1
  },

  premiumStatSub: {
    fontSize: ".6rem",
    color: "#94A3B8",
    marginTop: 4,
    fontWeight: 650,
    lineHeight: 1.2
  },
  premiumTableTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    padding: theme.spacing(1.2, 1.5),
    borderBottom: "1px solid #E2E8F0",
    background: "linear-gradient(135deg,#FFFFFF,#F8FAFC)",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch"
    }
  },
  premiumTableTitle: {
    color: "#0F172A",
    fontWeight: 950,
    fontSize: ".95rem"
  },
  premiumTableSubtitle: {
    color: "#64748B",
    fontSize: ".72rem",
    marginTop: 3
  },
  premiumMiniActions: {
    display: "flex",
    gap: theme.spacing(.8),
    flexWrap: "wrap"
  },
  premiumMiniBtn: {
    borderRadius: 14,
    border: "1px solid #E2E8F0",
    background: "#FFFFFF",
    color: "#334155",
    padding: "9px 12px",
    fontWeight: 900,
    fontSize: ".72rem",
    cursor: "pointer"
  },
  premiumMobileList: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
      paddingBottom: theme.spacing(10),
    }
  },
  premiumMobileCard: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
      borderRadius: 20,
      border: "1px solid #E2E8F0",
      background: "#FFFFFF",
      padding: theme.spacing(1.2),
      marginBottom: theme.spacing(1),
      boxShadow: "0 10px 24px rgba(15,23,42,.055)"
    }
  },
  premiumDesktopTable: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },

  // ESTILOS PARA A ABA MAPA
  legendContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    marginBottom: "20px",
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    margin: "5px 10px",
  },
  legendColor: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    marginRight: "5px",
    backgroundColor: "#FFA500",
  },
  totalContactsBar: {
    backgroundColor: theme.palette.primary.main, // usa cor primária do whitelabel
    padding: "10px",
    textAlign: "center",
    color: "white",
    marginBottom: "20px",
    borderRadius: "4px",
  },
  legendCard: {
    marginBottom: "20px",
    padding: "10px",
    backgroundColor: "#e8e8e8",
    borderRadius: "8px",
    boxShadow: "none",
  },

  // ESTILO DOS CARDS DE CONTATO (MODELO DA SUA PRINT)
  contactCard: {
    backgroundColor:
      theme.mode === "light" ? "#e7edf3" : theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  cardAvatar: {
    marginRight: theme.spacing(2),
    width: 48,
    height: 48,
  },
  cardNumber: {
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
  },
  cardName: {
    color: theme.palette.text.primary,
    fontWeight: 600,
  },
  cardLabel: {
    fontSize: "0.8rem",
    fontWeight: 500,
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.primary,
  },
  cardFooter: {
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  actionsRight: {
    display: "flex",
    gap: theme.spacing(1),
  },
  actionBtnWhats: {
    backgroundColor: "#25D366",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#1ebe5b",
    },
  },
  actionBtnEdit: {
    backgroundColor: "#2196f3",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#1976d2",
    },
  },
  actionBtnBlock: {
    backgroundColor: "#ff9800",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#fb8c00",
    },
  },
  actionBtnDelete: {
    backgroundColor: "#f44336",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#e53935",
    },
  },
}));

const Contacts = () => {
  const classes = useStyles();
  const history = useHistory();

  const { user, socket } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParam, setSearchParam] = useState("");
  const [contacts, dispatch] = useReducer(reducer, []);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [contactModalOpen, setContactModalOpen] = useState(false);

  const [importContactModalOpen, setImportContactModalOpen] = useState(false);
  const [deletingContact, setDeletingContact] = useState(null);
  const [ImportContacts, setImportContacts] = useState(null);

  const [blockingContact, setBlockingContact] = useState(null);
  const [unBlockingContact, setUnBlockingContact] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [exportContact, setExportContact] = useState(false);
  const [confirmChatsOpen, setConfirmChatsOpen] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [contactTicket, setContactTicket] = useState({});
  const fileUploadRef = useRef(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [overviewContactId, setOverviewContactId] = useState(null);
  const { setCurrentTicket } = useContext(TicketsContext);


  // SELEÇÃO EM MASSA
  const [selectedContactIds, setSelectedContactIds] = useState([]);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [confirmDeleteManyOpen, setConfirmDeleteManyOpen] = useState(false);

  const { getAll: getAllSettings } = useCompanySettings();
  const [hideNum, setHideNum] = useState(false);
  const [enableLGPD, setEnableLGPD] = useState(false);

  // CONTROLE DE ABAS (CONTATOS / MAPA)
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    async function fetchData() {
      const settingList = await getAllSettings(user.companyId);
      for (const [key, value] of Object.entries(settingList)) {
        if (key === "enableLGPD") setEnableLGPD(value === "enabled");
        if (key === "lgpdHideNumber") setHideNum(value === "enabled");
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleImportExcel = async () => {
    try {
      const formData = new FormData();
      formData.append("file", fileUploadRef.current.files[0]);
      await api.request({
        url: `/contacts/upload`,
        method: "POST",
        data: formData,
      });
      history.go(0);
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
    setSelectedContactIds([]);
    setIsSelectAllChecked(false);
  }, [searchParam, selectedTags]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await api.get("/contacts/", {
            params: {
              searchParam,
              pageNumber,
              contactTag: JSON.stringify(selectedTags),
            },
          });
          dispatch({ type: "LOAD_CONTACTS", payload: data.contacts });
          setHasMore(data.hasMore);
          setLoading(false);

          const allCurrentContactIds = data.contacts.map((c) => c.id);
          const newSelected = selectedContactIds.filter((id) =>
            allCurrentContactIds.includes(id)
          );
          setSelectedContactIds(newSelected);
          setIsSelectAllChecked(
            newSelected.length === allCurrentContactIds.length &&
              allCurrentContactIds.length > 0
          );
        } catch (err) {
          toastError(err);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber, selectedTags]);

  useEffect(() => {
    const companyId = user.companyId;
    const onContactEvent = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_CONTACTS", payload: data.contact });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_CONTACT", payload: +data.contactId });
        setSelectedContactIds((prevSelected) =>
          prevSelected.filter((id) => id !== +data.contactId)
        );
      }
    };
    socket.on(`company-${companyId}-contact`, onContactEvent);

    return () => {
      socket.off(`company-${companyId}-contact`, onContactEvent);
    };
  }, [socket, user.companyId]);

  const handleSelectTicket = (ticket) => {
    const code = uuidv4();
    const { id, uuid } = ticket;
    setCurrentTicket({ id, uuid, code });
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      handleSelectTicket(ticket);
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);
    setSelectedTags(tags);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleOpenContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(false);
  };

  const hadleEditContact = (contactId) => {
    setSelectedContactId(contactId);
    setContactModalOpen(true);
  };

  const handleDeleteContact = async (contactId) => {
    try {
      await api.delete(`/contacts/${contactId}`);
      toast.success(i18n.t("contacts.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
  };

  const handleToggleSelectContact = (contactId) => (event) => {
    if (event.target.checked) {
      setSelectedContactIds((prevSelected) => [...prevSelected, contactId]);
    } else {
      setSelectedContactIds((prevSelected) =>
        prevSelected.filter((id) => id !== contactId)
      );
      setIsSelectAllChecked(false);
    }
  };

  const handleSelectAllContacts = (event) => {
    const checked = event.target.checked;
    setIsSelectAllChecked(checked);

    if (checked) {
      const allContactIds = contacts.map((contact) => contact.id);
      setSelectedContactIds(allContactIds);
    } else {
      setSelectedContactIds([]);
    }
  };

  const handleDeleteSelectedContacts = async () => {
    try {
      setLoading(true);
      await api.delete("/contacts/batch-delete", {
        data: { contactIds: selectedContactIds },
      });
      toast.success("Contatos selecionados deletados com sucesso!");
      setSelectedContactIds([]);
      setIsSelectAllChecked(false);
      setConfirmDeleteManyOpen(false);
      dispatch({ type: "RESET" });
      setPageNumber(1);
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: false });
      dispatch({
        type: "UPDATE_CONTACTS",
        payload: { ...blockingContact, active: false },
      });
      toast.success("Contato bloqueado");
    } catch (err) {
      toastError(err);
    }
    setBlockingContact(null);
  };

  const handleUnBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: true });
      dispatch({
        type: "UPDATE_CONTACTS",
        payload: { ...unBlockingContact, active: true },
      });
      toast.success("Contato desbloqueado");
    } catch (err) {
      toastError(err);
    }
    setUnBlockingContact(null);
  };

  const handleimportContact = async (whatsappId) => {
    setImportContactModalOpen(false);

    try {
      await api.post("/contacts/import", { whatsappId });
      history.go(0);
      setImportContactModalOpen(false);
    } catch (err) {
      toastError(err);
      setImportContactModalOpen(false);
    }
  };

  const handleimportChats = async () => {
    try {
      await api.post("/contacts/import/chats");
      history.go(0);
    } catch (err) {
      toastError(err);
    }
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  // ===== FUNÇÃO PARA CONTAR CONTATOS POR ESTADO (USADA NO MAPA) =====
  const countContactsByState = () => {
    const stateCounts = {};

    contacts.forEach((contact) => {
      const number = contact.number;
      if (number && number.length > 4) {
        const ddd = number.substring(2, 4);
        if (dddList[ddd]) {
          const state = dddList[ddd];
          if (!stateCounts[state]) {
            stateCounts[state] = 0;
          }
          stateCounts[state]++;
        } else {
          if (!stateCounts["Outros"]) {
            stateCounts["Outros"] = 0;
          }
          stateCounts["Outros"]++;
        }
      }
    });

    return stateCounts;
  };

  const stateCounts = countContactsByState();

  return (
    <KoraxPage className={classes.pageRoot}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        initialContact={contactTicket}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <ContactModal
        open={contactModalOpen}
        onClose={handleCloseContactModal}
        aria-labelledby="form-dialog-title"
        contactId={selectedContactId}
      ></ContactModal>

      <ContactOverviewDrawer
        open={Boolean(overviewContactId)}
        contactId={overviewContactId}
        onClose={() => setOverviewContactId(null)}
        onEdit={(contactId) => hadleEditContact(contactId)}
        onStartConversation={(contact) => {
          setContactTicket(contact);
          setNewTicketModalOpen(true);
        }}
      />

      <ConfirmationModal
        title={
          deletingContact
            ? `${i18n.t(
                "contacts.confirmationModal.deleteTitle"
              )} ${deletingContact.name}?`
            : blockingContact
            ? `Bloquear Contato ${blockingContact.name}?`
            : unBlockingContact
            ? `Desbloquear Contato ${unBlockingContact.name}?`
            : ImportContacts
            ? `${i18n.t("contacts.confirmationModal.importTitlte")}`
            : `${i18n.t("contactListItems.confirmationModal.importTitlte")}`
        }
        isCellPhone={ImportContacts}
        open={confirmOpen}
        onClose={setConfirmOpen}
        onConfirm={(e) =>
          deletingContact
            ? handleDeleteContact(deletingContact.id)
            : blockingContact
            ? handleBlockContact(blockingContact.id)
            : unBlockingContact
            ? handleUnBlockContact(unBlockingContact.id)
            : ImportContacts
            ? handleimportContact(e)
            : handleImportExcel()
        }
      >
        {exportContact
          ? `${i18n.t("contacts.confirmationModal.exportContact")}`
          : deletingContact
          ? `${i18n.t("contacts.confirmationModal.deleteMessage")}`
          : blockingContact
          ? `${i18n.t("contacts.confirmationModal.blockContact")}`
          : unBlockingContact
          ? `${i18n.t("contacts.confirmationModal.unblockContact")}`
          : ImportContacts
          ? `Escolha de qual conexão deseja importar`
          : `${i18n.t(
              "contactListItems.confirmationModal.importMessage"
            )}`}
      </ConfirmationModal>

      <ConfirmationModal
        title={`Tem certeza que deseja deletar ${selectedContactIds.length} contatos selecionados?`}
        open={confirmDeleteManyOpen}
        onClose={() => setConfirmDeleteManyOpen(false)}
        onConfirm={handleDeleteSelectedContacts}
      >
        Essa ação é irreversível.
      </ConfirmationModal>

      <ConfirmationModal
        title={i18n.t("contacts.confirmationModal.importChat")}
        open={confirmChatsOpen}
        onClose={setConfirmChatsOpen}
        onConfirm={(e) => handleimportChats()}
      >
        {i18n.t("contacts.confirmationModal.wantImport")}
      </ConfirmationModal>

      {/* =====================================================
          KORAX CLIENTES PREMIUM
      ====================================================== */}
      <MainHeader>
        <Grid
          container
          style={{
            width: "100%"
          }}
        >
          <Grid item xs={12}>
            <KoraxPageHeader
              title="Clientes"
              subtitle="Toda a sua base e o histórico de relacionamento em um só lugar."
              actions={
                <KoraxButton
                  variant="primary"
                  onClick={handleOpenContactModal}
                >
                  + Novo cliente
                </KoraxButton>
              }
            />
          </Grid>
        </Grid>
      </MainHeader>

      <Paper
        elevation={0}
        style={{
          marginBottom: 16,
          padding: 16,
          borderRadius: 18,
          border: "1px solid #E5EAF1",
          background: "#FFFFFF",
          boxShadow: "0 10px 30px rgba(15,23,42,.045)"
        }}
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
        >
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              placeholder="Buscar por nome, telefone ou e-mail..."
              type="search"
              value={searchParam}
              onChange={handleSearch}
              variant="outlined"
              className={classes.searchField}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      style={{
                        color: "#64748B"
                      }}
                    />
                  </InputAdornment>
                )
              }}
            />
          </Grid>

          <Grid item xs={12} sm={8} md={4}>
            <TagsFilter
              onFiltered={handleSelectedTags}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={2}>
            <PopupState
              variant="popover"
              popupId="contacts-actions-menu"
            >
              {(popupState) => (
                <React.Fragment>
                  <Button
                    fullWidth
                    variant="outlined"
                    {...bindTrigger(popupState)}
                    style={{
                      minHeight: 42,
                      borderRadius: 11,
                      borderColor: "#DCE3EC",
                      color: "#475569",
                      textTransform: "none",
                      fontWeight: 800,
                      background: "#FFFFFF"
                    }}
                  >
                    Ações
                    <ArrowDropDown />
                  </Button>

                  <Menu {...bindMenu(popupState)}>
                    <MenuItem
                      onClick={() => {
                        setConfirmOpen(true);
                        setImportContacts(true);
                        popupState.close();
                      }}
                    >
                      <ContactPhone
                        fontSize="small"
                        style={{
                          marginRight: 10,
                          color: "#2563EB"
                        }}
                      />
                      Importar do telefone
                    </MenuItem>

                    <MenuItem
                      onClick={() => {
                        setImportContactModalOpen(true);
                        popupState.close();
                      }}
                    >
                      <Backup
                        fontSize="small"
                        style={{
                          marginRight: 10,
                          color: "#2563EB"
                        }}
                      />
                      Importar planilha
                    </MenuItem>

                    {selectedContactIds.length > 0 && (
                      <MenuItem
                        onClick={() => {
                          setConfirmDeleteManyOpen(true);
                          popupState.close();
                        }}
                        style={{
                          color: "#DC2626"
                        }}
                      >
                        <DeleteOutlineIcon
                          fontSize="small"
                          style={{
                            marginRight: 10
                          }}
                        />
                        Excluir selecionados
                      </MenuItem>
                    )}
                  </Menu>
                </React.Fragment>
              )}
            </PopupState>
          </Grid>
        </Grid>

        <Box
          display="flex"
          alignItems="center"
          flexWrap="wrap"
          style={{
            gap: 8,
            marginTop: 14
          }}
        >
          <Box
            style={{
              padding: "6px 10px",
              borderRadius: 999,
              background: "#F1F5F9",
              color: "#475569",
              fontSize: 10.5,
              fontWeight: 800
            }}
          >
            {contacts.length} carregados
          </Box>

          <Box
            style={{
              padding: "6px 10px",
              borderRadius: 999,
              background: "#F0FDF4",
              color: "#15803D",
              fontSize: 10.5,
              fontWeight: 800
            }}
          >
            {contacts.filter(contact => contact.active).length} ativos
          </Box>

          {selectedContactIds.length > 0 && (
            <Box
              style={{
                padding: "6px 10px",
                borderRadius: 999,
                background: "#EFF6FF",
                color: "#2563EB",
                fontSize: 10.5,
                fontWeight: 800
              }}
            >
              {selectedContactIds.length} selecionado
              {selectedContactIds.length === 1 ? "" : "s"}
            </Box>
          )}
        </Box>
      </Paper>

      {importContactModalOpen && (
        <ContactImportWpModal
          isOpen={importContactModalOpen}
          handleClose={() => setImportContactModalOpen(false)}
          selectedTags={selectedTags}
          hideNum={hideNum}
          userProfile={user.profile}
        />
      )}

      {/* ABAS CONTATOS / MAPA */}
      <Paper elevation={0} className={classes.tabsWrap}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="abas-contatos-mapa"
          className={classes.tabsRoot}
        >
          <Tab label="Contatos" />
          <Tab label="Mapa" />
        </Tabs>
      </Paper>

      <Paper
        className={classes.mainPaper}
        variant="outlined"
        onScroll={handleScroll}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexWrap="wrap"
          style={{
            gap: 12,
            padding: "18px 20px",
            borderBottom: "1px solid #EEF2F7"
          }}
        >
          <Box>
            <Typography
              style={{
                color: "#0F172A",
                fontSize: 15,
                fontWeight: 950,
                letterSpacing: "-.02em"
              }}
            >
              Base de clientes
            </Typography>

            <Typography
              style={{
                marginTop: 4,
                color: "#94A3B8",
                fontSize: 10.5
              }}
            >
              Clique em um cliente para visualizar todo o relacionamento.
            </Typography>
          </Box>

          <Box
            display="flex"
            alignItems="center"
            style={{
              gap: 7
            }}
          >
            <Box
              style={{
                width: 7,
                height: 7,
                borderRadius: "50%",
                background: "#22C55E"
              }}
            />

            <Typography
              style={{
                color: "#64748B",
                fontSize: 10.5,
                fontWeight: 750
              }}
            >
              {contacts.length} clientes carregados
            </Typography>
          </Box>
        </Box>

        <>
          <input
            style={{ display: "none" }}
            id="upload"
            name="file"
            type="file"
            accept=".xls,.xlsx"
            onChange={() => {
              setConfirmOpen(true);
            }}
            ref={fileUploadRef}
          />
        </>

        {/* ABA CONTATOS EM CARDS */}
        {tabValue === 0 && (
          <Box p={2}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              style={{
                marginBottom: 10
              }}
            >
              <Box
                display="flex"
                alignItems="center"
              >
                <Checkbox
                  size="small"
                  checked={isSelectAllChecked}
                  onChange={handleSelectAllContacts}
                  inputProps={{
                    "aria-label": "Selecionar todos os contatos"
                  }}
                />

                <Typography
                  style={{
                    color: "#64748B",
                    fontSize: 10.5,
                    fontWeight: 700
                  }}
                >
                  Selecionar página
                </Typography>
              </Box>

              {selectedContactIds.length > 0 && (
                <Typography
                  style={{
                    color: "#2563EB",
                    fontSize: 10.5,
                    fontWeight: 850
                  }}
                >
                  {selectedContactIds.length} selecionado
                  {selectedContactIds.length === 1 ? "" : "s"}
                </Typography>
              )}
            </Box>


            <div className={classes.premiumMobileList}>
              {contacts.map((contact) => (
                <div
                  key={`mobile-${contact.id}`}
                  className={classes.premiumMobileCard}
                  onClick={() => setOverviewContactId(contact.id)}
                  style={{ cursor: "pointer" }}
                >
                  <Box display="flex" alignItems="center" justifyContent="space-between" style={{ gap: 10 }}>
                    <Box display="flex" alignItems="center" style={{ gap: 10, minWidth: 0 }}>
                      <Checkbox
                        checked={selectedContactIds.includes(contact.id)}
                        onChange={handleToggleSelectContact(contact.id)}
                      />
                      <Avatar src={contact?.urlPicture} style={{ width: 42, height: 42 }}>
                        {contact.name?.slice(0, 1)}
                      </Avatar>
                      <div style={{ minWidth: 0 }}>
                        <Typography style={{ fontWeight: 900, fontSize: ".9rem", color: "#0F172A", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {contact.name || "-"}
                        </Typography>
                        <Typography style={{ color: "#64748B", fontSize: ".75rem", marginTop: 2 }}>
                          {contact.isGroup ? contact.number : formatSerializedId(contact?.number)}
                        </Typography>
                      </div>
                    </Box>

                    <Chip
                      label={contact.active ? "Ativo" : "Bloqueado"}
                      size="small"
                      style={{
                        fontWeight: 900,
                        background: contact.active ? "rgba(34,197,94,.12)" : "rgba(239,68,68,.12)",
                        color: contact.active ? "#16A34A" : "#EF4444",
                      }}
                    />
                  </Box>

                  <Box display="flex" alignItems="center" justifyContent="space-between" mt={1.2}>
                    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                      {contact.channel === "whatsapp" && <WhatsApp style={{ fontSize: 18, color: "#25d366" }} />}
                      {contact.channel === "instagram" && <Instagram style={{ fontSize: 18, color: "#e1306c" }} />}
                      {contact.channel === "facebook" && <Facebook style={{ fontSize: 18, color: "#3b5998" }} />}
                      <Typography style={{ color: "#64748B", fontSize: ".74rem" }}>{contact.email || "Sem email"}</Typography>
                    </Box>

                    <Box
                      display="flex"
                      style={{ gap: 6 }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      <IconButton size="small" disabled={!contact.active}
                        style={{ border: "1px solid rgba(37,211,102,0.2)", color: "#25d366", borderRadius: 10, padding: 6 }}
                        onClick={() => { setContactTicket(contact); setNewTicketModalOpen(true); }}>
                        {contact.channel === "whatsapp" && <WhatsApp style={{ fontSize: 15 }} />}
                        {contact.channel === "instagram" && <Instagram style={{ fontSize: 15 }} />}
                        {contact.channel === "facebook" && <Facebook style={{ fontSize: 15 }} />}
                      </IconButton>
                      <IconButton size="small"
                        style={{ border: "1px solid rgba(0,102,255,0.2)", color: "#0066FF", borderRadius: 10, padding: 6 }}
                        onClick={() => hadleEditContact(contact.id)}>
                        <EditIcon style={{ fontSize: 15 }} />
                      </IconButton>
                    </Box>
                  </Box>
                </div>
              ))}
            </div>

            {/* =====================================================
                KORAX CLIENT CENTER V2
            ====================================================== */}
            <Box
              className={classes.premiumDesktopTable}
              style={{
                display: "grid",
                gap: 10
              }}
            >
              {contacts.length === 0 && !loading && (
                <Box
                  style={{
                    padding: "48px 20px",
                    borderRadius: 18,
                    border: "1px dashed #CBD5E1",
                    background: "#F8FAFC",
                    textAlign: "center"
                  }}
                >
                  <Typography
                    style={{
                      color: "#0F172A",
                      fontSize: 14,
                      fontWeight: 900
                    }}
                  >
                    Nenhum cliente encontrado
                  </Typography>

                  <Typography
                    style={{
                      color: "#94A3B8",
                      fontSize: 11,
                      marginTop: 5
                    }}
                  >
                    Ajuste a busca ou adicione um novo cliente.
                  </Typography>
                </Box>
              )}

              {contacts.map((contact) => (
                <Paper
                  key={`client-center-${contact.id}`}
                  elevation={0}
                  onClick={() => setOverviewContactId(contact.id)}
                  style={{
                    padding: "16px 18px",
                    borderRadius: 17,
                    border: "1px solid #E5EAF1",
                    background: "#FFFFFF",
                    boxShadow: "0 5px 18px rgba(15,23,42,.035)",
                    cursor: "pointer",
                    transition:
                      "transform .18s ease, box-shadow .18s ease, border-color .18s ease"
                  }}
                  onMouseEnter={(event) => {
                    event.currentTarget.style.transform = "translateY(-2px)";
                    event.currentTarget.style.boxShadow =
                      "0 14px 32px rgba(15,23,42,.08)";
                    event.currentTarget.style.borderColor =
                      "rgba(37,99,235,.22)";
                  }}
                  onMouseLeave={(event) => {
                    event.currentTarget.style.transform = "translateY(0)";
                    event.currentTarget.style.boxShadow =
                      "0 5px 18px rgba(15,23,42,.035)";
                    event.currentTarget.style.borderColor = "#E5EAF1";
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    style={{
                      gap: 18
                    }}
                  >
                    {/* CLIENTE */}
                    <Box
                      display="flex"
                      alignItems="center"
                      style={{
                        gap: 13,
                        minWidth: 0,
                        flex: "1 1 32%"
                      }}
                    >
                      <Box
                        style={{
                          position: "relative",
                          flexShrink: 0
                        }}
                      >
                        <Avatar
                          src={contact?.urlPicture}
                          style={{
                            width: 48,
                            height: 48,
                            background:
                              "linear-gradient(135deg,#E2E8F0,#CBD5E1)",
                            color: "#475569",
                            fontWeight: 900,
                            fontSize: 16
                          }}
                        >
                          {String(contact.name || "C")
                            .slice(0, 1)
                            .toUpperCase()}
                        </Avatar>

                        {contact.active && (
                          <Box
                            style={{
                              position: "absolute",
                              right: -1,
                              bottom: -1,
                              width: 12,
                              height: 12,
                              borderRadius: "50%",
                              background: "#22C55E",
                              border: "2px solid #FFFFFF"
                            }}
                          />
                        )}
                      </Box>

                      <Box
                        style={{
                          minWidth: 0
                        }}
                      >
                        <Typography
                          style={{
                            color: "#0F172A",
                            fontSize: 13,
                            fontWeight: 900,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                          }}
                        >
                          {contact.name || "Sem nome"}
                        </Typography>

                        <Typography
                          style={{
                            color: "#64748B",
                            fontSize: 10.5,
                            marginTop: 4
                          }}
                        >
                          {contact.isGroup
                            ? contact.number
                            : formatSerializedId(contact?.number) ||
                              contact.number}
                        </Typography>

                        {contact.email && (
                          <Typography
                            style={{
                              color: "#94A3B8",
                              fontSize: 9.5,
                              marginTop: 2,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis"
                            }}
                          >
                            {contact.email}
                          </Typography>
                        )}
                      </Box>
                    </Box>

                    {/* RELACIONAMENTO */}
                    <Box
                      style={{
                        minWidth: 160,
                        flex: "1 1 22%"
                      }}
                    >
                      <Typography
                        style={{
                          color: "#94A3B8",
                          fontSize: 9,
                          fontWeight: 800,
                          letterSpacing: ".05em",
                          textTransform: "uppercase"
                        }}
                      >
                        Relacionamento
                      </Typography>

                      <Box
                        display="flex"
                        alignItems="center"
                        flexWrap="wrap"
                        style={{
                          gap: 6,
                          marginTop: 7
                        }}
                      >
                        {contact.channel === "whatsapp" && (
                          <Box
                            display="flex"
                            alignItems="center"
                            style={{
                              gap: 5,
                              padding: "5px 8px",
                              borderRadius: 8,
                              background: "#F0FDF4",
                              color: "#15803D",
                              fontSize: 9.5,
                              fontWeight: 850
                            }}
                          >
                            <WhatsApp
                              style={{
                                fontSize: 13
                              }}
                            />
                            WhatsApp
                          </Box>
                        )}

                        {contact.channel === "instagram" && (
                          <Box
                            style={{
                              padding: "5px 8px",
                              borderRadius: 8,
                              background: "#FDF2F8",
                              color: "#BE185D",
                              fontSize: 9.5,
                              fontWeight: 850
                            }}
                          >
                            Instagram
                          </Box>
                        )}

                        {contact.channel === "facebook" && (
                          <Box
                            style={{
                              padding: "5px 8px",
                              borderRadius: 8,
                              background: "#EFF6FF",
                              color: "#1D4ED8",
                              fontSize: 9.5,
                              fontWeight: 850
                            }}
                          >
                            Facebook
                          </Box>
                        )}
                      </Box>

                      {contact.tags?.length > 0 && (
                        <Box
                          display="flex"
                          flexWrap="wrap"
                          style={{
                            gap: 4,
                            marginTop: 7
                          }}
                        >
                          {contact.tags.slice(0, 2).map(tag => (
                            <Chip
                              key={tag.id}
                              size="small"
                              label={tag.name}
                              style={{
                                height: 20,
                                fontSize: 8.5,
                                background: "#F8FAFC",
                                color: "#64748B"
                              }}
                            />
                          ))}

                          {contact.tags.length > 2 && (
                            <Typography
                              style={{
                                color: "#94A3B8",
                                fontSize: 9,
                                alignSelf: "center"
                              }}
                            >
                              +{contact.tags.length - 2}
                            </Typography>
                          )}
                        </Box>
                      )}
                    </Box>

                    {/* STATUS */}
                    <Box
                      style={{
                        minWidth: 100,
                        flex: "0 0 110px"
                      }}
                    >
                      <Typography
                        style={{
                          color: "#94A3B8",
                          fontSize: 9,
                          fontWeight: 800,
                          letterSpacing: ".05em",
                          textTransform: "uppercase"
                        }}
                      >
                        Status
                      </Typography>

                      <Box
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 5,
                          marginTop: 7,
                          padding: "5px 9px",
                          borderRadius: 999,
                          background: contact.active
                            ? "#F0FDF4"
                            : "#FEF2F2",
                          color: contact.active
                            ? "#15803D"
                            : "#B91C1C",
                          fontSize: 9.5,
                          fontWeight: 900
                        }}
                      >
                        <span>●</span>
                        {contact.active ? "Ativo" : "Bloqueado"}
                      </Box>
                    </Box>

                    {/* AÇÕES */}
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="flex-end"
                      style={{
                        gap: 7,
                        flex: "0 0 auto"
                      }}
                      onClick={(event) =>
                        event.stopPropagation()
                      }
                    >
                      <Button
                        size="small"
                        onClick={() =>
                          setOverviewContactId(contact.id)
                        }
                        style={{
                          minHeight: 34,
                          padding: "0 11px",
                          borderRadius: 9,
                          background: "#EFF6FF",
                          color: "#155EEF",
                          textTransform: "none",
                          fontSize: 9.5,
                          fontWeight: 900
                        }}
                      >
                        Ver cliente 360º
                      </Button>

                      <Tooltip title="Conversar">
                        <IconButton
                          size="small"
                          disabled={!contact.active}
                          onClick={() => {
                            setContactTicket(contact);
                            setNewTicketModalOpen(true);
                          }}
                          style={{
                            width: 34,
                            height: 34,
                            borderRadius: 9,
                            border: "1px solid #DCFCE7",
                            color: "#16A34A",
                            background: "#F0FDF4"
                          }}
                        >
                          <WhatsApp
                            style={{
                              fontSize: 15
                            }}
                          />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Editar cliente">
                        <IconButton
                          size="small"
                          onClick={() =>
                            hadleEditContact(contact.id)
                          }
                          style={{
                            width: 34,
                            height: 34,
                            borderRadius: 9,
                            border: "1px solid #DBEAFE",
                            color: "#2563EB",
                            background: "#EFF6FF"
                          }}
                        >
                          <EditIcon
                            style={{
                              fontSize: 15
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                </Paper>
              ))}
            </Box>

            {loading && (
              <Box mt={2}>
                <Grid container spacing={2}>
                  {Array.from({ length: 6 }).map((_, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={`contacts-skeleton-${index}`}>
                      <Card className={classes.contactCard}>
                        <CardContent>
                          <Box display="flex" alignItems="center" mb={1.5}>
                            <Skeleton variant="circle" width={40} height={40} />
                            <Box ml={1.5} flex={1}>
                              <Skeleton variant="text" width="70%" height={22} />
                              <Skeleton variant="text" width="45%" height={18} />
                            </Box>
                          </Box>
                          <Skeleton variant="rect" height={36} />
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}
          </Box>
        )}

        {/* ABA MAPA */}
        {tabValue === 1 && (
          <>
            <Box className={classes.totalContactsBar}>
              <Typography variant="h6">
                Total de Contatos por Estado: {contacts.length}
              </Typography>
            </Box>

            <Box p={3}>
              <Card className={classes.legendCard}>
                <CardContent>
                  <Box className={classes.legendContainer}>
                    {Object.entries(stateCounts).map(([state, count]) => (
                      <Box key={state} className={classes.legendItem}>
                        <div className={classes.legendColor} />
                        <Typography variant="body2">
                          {state}: {count} contato(s)
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </CardContent>
              </Card>

              <ComposableMap
                projection="geoMercator"
                projectionConfig={{
                  scale: 600,
                  center: [-53, -15],
                }}
                style={{ width: "100%", height: "auto" }}
              >
                <Geographies geography={geoUrl}>
                  {({ geographies }) =>
                    geographies.map((geo) => {
                      const state = geo.properties.name;
                      const count = stateCounts[state] || 0;

                      return (
                        <Geography
                          key={geo.rsmKey}
                          geography={geo}
                          fill={count > 0 ? "#FFA500" : "#EAEAEC"}
                          stroke="#D6D6DA"
                          style={{
                            hover: {
                              fill: "#FFA500",
                              stroke: "#D6D6DA",
                            },
                          }}
                        />
                      );
                    })
                  }
                </Geographies>
                {markers.map(({ name, coordinates, markerOffset }) => (
                  <Marker key={name} coordinates={coordinates}>
                    <circle
                      r={5}
                      fill="#F00"
                      stroke="#fff"
                      strokeWidth={1}
                    />
                    <text
                      textAnchor="middle"
                      y={markerOffset}
                      style={{
                        fontFamily: "system-ui",
                        fill: "#5D5A6D",
                        fontSize: "12px",
                      }}
                    >
                      {name}
                    </text>
                  </Marker>
                ))}
              </ComposableMap>
            </Box>
          </>
        )}
      </Paper>
    </KoraxPage>
  );
};

export default Contacts;
